import axios from "axios";
import {
  FETCH_PAYMENT_TYPE,
  CREATE_PAYMENT_TYPE,
  UPDATE_PAYMENT_TYPE,
  DELETE_PAYMENT_TYPE,
  DELETE_M_PAYMENT_TYPE,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function addPaymentType(item) {
  return {
    type: CREATE_PAYMENT_TYPE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/payment_type/`, item, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchPaymentType() {
  return {
    type: FETCH_PAYMENT_TYPE,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/payment_type/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updatePaymentType(id, data) {
  return {
    type: UPDATE_PAYMENT_TYPE,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/payment_type/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deletePaymentType(id) {
  return {
    type: DELETE_PAYMENT_TYPE,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/payment_type/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteMultiplePaymentType(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_M_PAYMENT_TYPE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/payment_type/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
